/**
 * Created by piotr.pozniak@thebeaverhead.com on 27/05/2025
 */

import React from "react";
import classNames from "classnames";

/**
 * FlatAlert component displays an alert with an icon and a message.
 * @param {string="info"}icon
 * @param {string="info"} errorLevel
 * @param {string} className
 * @param {Object|string|function} children
 * @returns {Element}
 * @constructor
 */
const FlatAlert = ({
  icon = "info",
  errorLevel = "info",
  className = "",
  children,
}) => {
  return (
    <div
      className={classNames(
        `alert alert-${errorLevel} alert-expandable`,
        className
      )}
    >
      <div>
        <i className={"material-icons glowing-icon"}>{icon}</i>
      </div>
      <div className={"alert-expandable-content"}>
        <div className={"alert-expandable-header "}>
          <div className={"title"}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default FlatAlert;
